import React from 'react'
import { Switch, Route, withRouter } from 'react-router-dom'

import { PATHS } from 'Config/Routing/paths'
import APIIntegration from '../../Containers/Integrations/API'
import { authorization } from '../../Module/Auth/Auth'
import AddSwellStore from '../../Containers/Integrations/Ecommerce/pages/AddSwellStore'
import SwellStores from '../../Containers/Integrations/Ecommerce/pages/SwellStores'

const IntegrationRouter = props => {
  const {
    match: { url },
  } = props

  const isApiIntegrationEnabled =
    authorization.isApiIntegrationEnabled() && authorization.isClientAdmin()
  return (
    <Switch>
      <Route
        exact
        path={
          PATHS.main.dashboard +
          PATHS.dashboard.integrations +
          PATHS.integrations.swellStores
        }
      >
        <SwellStores url={url} />
      </Route>
      <Route
        path={
          PATHS.main.dashboard +
          PATHS.dashboard.integrations +
          PATHS.integrations.swellStores +
          PATHS.integrations.addSwellStore
        }
      >
        <AddSwellStore url={url} />
      </Route>

      {isApiIntegrationEnabled ? (
        <Route
          exact
          path={
            PATHS.main.dashboard +
            PATHS.dashboard.integrations +
            PATHS.integrations.api
          }
        >
          <APIIntegration url={url} />
        </Route>
      ) : null}
    </Switch>
  )
}

export default withRouter(IntegrationRouter)
